var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content"},[_c('ByIcon',{attrs:{"icon":"oops","size":"300"}}),_c('h2',[_vm._v("404")]),_c('p',[_vm._v("找不到此頁面")])],1),_c('ByFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }